import {StateGroupItem, StateItem} from "../../../core/StateGroup";
import React from "react";

export default function AppointmentStateColumn({row, text}) {
    return (
        <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <StateItem
                text={text}
                color={row.stateColor}
                showColor={true}
            />

            <StateGroupItem
                id={row.stateGroupId}
            />
        </div>
    )
}